import { render, staticRenderFns } from "./CheckModal.vue?vue&type=template&id=54c8823f&scoped=true&"
import script from "./CheckModal.vue?vue&type=script&lang=js&"
export * from "./CheckModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c8823f",
  null
  
)

export default component.exports